import { courts, CourtType } from "csv-package";

const getCourtByPostcode = (postcode: string): CourtType | null => {
  const court = courts.find((court) =>
    court.court_postcodes.includes(postcode)
  );
  if (court === undefined) {
    return null;
  }
  return court;
};

export default getCourtByPostcode;
